import { render, staticRenderFns } from "./TabCreations.vue?vue&type=template&id=16e9b467&"
import script from "./TabCreations.vue?vue&type=script&lang=ts&"
export * from "./TabCreations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports